
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import EnlargeSvg from './svg/EnlargeSvg.vue';

export default defineComponent({
  name: 'EnlargeIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      EnlargeSvg: markRaw(EnlargeSvg)
    };
  }
});
